import { Provider } from '@angular/core';
import {
  DictionaryEntry,
  DYNAMIC_CONFIG_TOKEN,
} from 'libs/platform/dynamic-components/src/lib/services/config-fetchers/fetch-config-from-code.service';

import { common } from '.';

const commonConfigs: DictionaryEntry[] = [
  [
    'common:horizontal-scrollable-panel-p-basket-search',
    [common.horizontalScrollablePanelPBasketSearch],
  ],
  [
    'common:horizontal-scrollable-panel-from-list',
    [common.horizontalScrollablePanelFromList],
  ],
  ['common:panel-from-list', [common.panelFromListRoot]],
  ['common:square-panel-from-list', [common.squarePanelFromList]],
  [
    'common:square-panel-from-list-single-product',
    [common.squarePanelFromListSingleProduct],
  ],
  [
    'common:square-panel-products-on-the-way',
    [common.squarePanelFromRecommendationsProductsOnTheWay],
  ],
  [
    'common:square-panel-best-performing-articles',
    [common.squarePanelFromRecommendationsBestPerformingArticles],
  ],
  [
    'common:square-panel-best-performing-articles-global',
    [common.squarePanelFromRecommendationsBestPerformingArticlesGlobal],
  ],
  ['common:search-bar-base-panel', [common.searchBarBasePanel]],
  ['common:search-bar-panel', [common.searchBarPanel]],
  ['common:square-panel-from-search', [common.squarePanelFromSearch]],
  ['common:sliding-carousel', [common.slidingCarouselPanel]],
  ['common:pockets-look-ahead-container', [common.pocketsLookAheadContainer]],
  [
    'common:horizontal-scrollable-panel-products-on-the-way',
    [common.horizontalScrollablePanelProductsOnTheWay],
  ],
  ['common:pills-navigation', [common.pillsNavigation]],
  ['common:user-feedback', [common.userFeedbackPanel]],
];

export const commonConfigsInjectionTokenProvider: Provider = {
  provide: DYNAMIC_CONFIG_TOKEN,
  useValue: commonConfigs,
  multi: true,
};
